import { render, staticRenderFns } from "./TrTestMultiV2.vue?vue&type=template&id=87ed746c&scoped=true&"
import script from "./TrTestMultiV2.vue?vue&type=script&lang=js&"
export * from "./TrTestMultiV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTestMultiV2.vue?vue&type=style&index=0&id=87ed746c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ed746c",
  null
  
)

export default component.exports